import React, { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { 
    Button, 
    DialogContent, 
    DialogTitle, 
    DialogActions, 
    Dialog, 
    Grid, 
    TextField,
    FormControlLabel,
    Checkbox
} from '@material-ui/core';

import { useNotify } from '../../hooks/useNotify';
import { doSwaggerCall } from '../../hooks/useSwaggerClient';

function CreateNewCancelReasonModal({ showModal, MODAL_TYPE }) {
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [requiresNote, setRequiresNote] = useState(false);
    const { notifySuccess, notifyError } = useNotify();
    const history = useHistory();

    const createCancelReason = useCallback(() => {
        doSwaggerCall('cancelreasons', 'createCancelReason', {
            cancelReason: {
                name,
                description,
                requires_note: requiresNote
            }
        })
            .then(newCancelReason => {
                notifySuccess('New cancel reason created!');
                showModal(MODAL_TYPE.NONE);
                history.push(`/admin/cancelreasons/update/${newCancelReason.id}`);
            })
            .catch(err => {
                console.log(err);
                notifyError('Error during cancel reason creation!');
            });
    }, [name, description, requiresNote, notifySuccess, notifyError, showModal, history]);

    return (
        <form>
            <Dialog
                aria-labelledby="cancel-reason-modal"
                open
                onClose={() => showModal(MODAL_TYPE.NONE)}
                maxWidth="md"
            >
                <DialogTitle>Create new cancel reason</DialogTitle>
                <DialogContent>
                    <form
                        id="newcancelreason-form"
                        onSubmit={ev => {
                            ev.preventDefault();
                            createCancelReason();
                        }}
                    >
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    label="Name"
                                    type="text"
                                    required
                                    value={name}
                                    onChange={ev => setName(ev.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    label="Description"
                                    type="text"
                                    multiline
                                    rows={3}
                                    value={description}
                                    onChange={ev => setDescription(ev.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={requiresNote}
                                            onChange={ev => setRequiresNote(ev.target.checked)}
                                            color="primary"
                                        />
                                    }
                                    label="Requires additional note when used"
                                />
                            </Grid>
                        </Grid>
                    </form>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" onClick={() => showModal(MODAL_TYPE.NONE)}>
                        Close
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        disabled={!name}
                        type="submit"
                        form="newcancelreason-form"
                    >
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>
        </form>
    );
}

export default CreateNewCancelReasonModal;